import { ChangeEvent } from 'react';

import { Button } from '@/components/ui/button';

interface AddDomainCidrFormProps {
  onTextChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  textInput: string;
  onOpenImport: () => void;
}

export const AddDomainCidrForm = ({
  onTextChange,
  textInput,
  onOpenImport,
}: AddDomainCidrFormProps) => {
  return (
    <div className="flex flex-col gap-2">
      {/* Text Input Section */}
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-bold">Add Domains/CIDR Ranges</h3>
        <p className="text-chariot-text-secondary text-sm">
          Enter one per line:
        </p>
        <textarea
          className="bg-chariot-background-primary border-chariot-stroke text-chariot-text-primary focus:border-chariot-brand-primary h-32 rounded-lg border-2 p-3 font-mono text-sm focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
          placeholder={'example.com\n192.168.1.0/24\nsubdomain.example.com'}
          value={textInput}
          onChange={onTextChange}
        />
      </div>
      {/* Divider */}
      <p className="text-chariot-text-secondary text-center text-sm">or</p>
      {/* Import Button Section */}
      <div className="flex flex-col gap-2">
        <Button onClick={onOpenImport} variant="secondary" className="w-full">
          Import from File
        </Button>
        <p className="text-chariot-text-secondary text-center text-xs">
          Import domains or CIDR ranges from a file
        </p>
      </div>
    </div>
  );
};
